import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { HistoryService } from '@repos/businesses/sales/history.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { Matter } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { UserProfileState } from '@state/user-profile';

@UntilDestroy()
@Component({
	selector: 'app-history',
	templateUrl: './history.component.html',
	standalone: false,
})
export class HistoryComponent implements OnInit, OnDestroy {
	@ViewChild(MatSort) sort: MatSort;

	public dataSource;

	displayedColumns: string[] = [
		'lastUpdatedAt',
		'userName',
		'property',
		'from',
		'to',
	];

	@Select(SelectedMatter.getSelected) sale$: Observable<Matter>;
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId;

	public sale: Matter | null;

	private saleSubscription: Subscription;

	constructor(private historyService: HistoryService) {}

	ngOnDestroy(): void {
		this.saleSubscription.unsubscribe();
	}

	ngOnInit(): void {
		this.saleSubscription = this.sale$.subscribe((value) => {
			this.sale = value;
			if (this.sale != null) {
				this.getHistory();
			}
		});
	}

	getHistory = () => {
		this.historyService
			.All({ businessId: this.businessId, matterId: this.sale.id }, (ref) =>
				ref.orderBy('date', 'desc'),
			)
			.pipe(untilDestroyed(this))
			.subscribe((data) => {
				this.dataSource = new MatTableDataSource(data);
				this.dataSource.sort = this.sort;
			});
	};

	applyFilter = (filterValue: string): void => {
		filterValue = filterValue.trim();
		filterValue = filterValue.toLowerCase();
		this.dataSource.filter = filterValue;
	};

	trackById = (index, item) => item.id;

	getValue = (property, value) => {
		switch (property) {
			case 'clients':
				return value ? value.map((val) => val.name).join(', ') : value;
			default:
				return value;
		}
	};
}
